import {createAction, handleActions} from 'redux-actions';
import {Record} from 'immutable';

const INITIALIZE_CORE = '@@core/INITIALIZE_CORE';
const SET_OS = '@@core/SET_OS';
const SET_LANGUAGE = '@@core/SET_LANGUAGE';

export const actionCreators = {
  initializeCore: createAction(INITIALIZE_CORE),
  setOS: createAction(SET_OS),
  setLanguage: createAction(SET_LANGUAGE)
};

const NestRecord = Record({
  OS: '',
  language: ''
});

const initialState = NestRecord();

export default handleActions({
  [INITIALIZE_CORE]: () => initialState,
  [SET_OS]: (state, {payload: OS}) => state.set('OS', OS),
  [SET_LANGUAGE]: (state, {payload: language}) => state.set('language', language)
}, initialState);


// WEBPACK FOOTER //
// ./src/store/modules/core.js